import { render, staticRenderFns } from "./Creations-menu.vue?vue&type=template&id=59b56842"
import script from "./Creations-menu.vue?vue&type=script&lang=js"
export * from "./Creations-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports